import React, { useState } from 'react';

function MyFolder() {
  // Mock data for folders and documents (replace with actual data)
  const [folders, setFolders] = useState([
    { id: 1, name: 'Folder 1', documents: ['Document 1', 'Document 2'] },
    { id: 2, name: 'Folder 2', documents: ['Document 3', 'Document 4'] },
    // Add more folders as needed
  ]);

  const [selectedFolder, setSelectedFolder] = useState(null);

  // Function to toggle folder view
  const toggleFolder = (folderId) => {
    if (selectedFolder === folderId) {
      setSelectedFolder(null); // Close folder if already open
    } else {
      setSelectedFolder(folderId); // Open folder
    }
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">My folders</h2>
        <div className="flex space-x-4 ml-auto">
          <button className="bg-blue-500 text-white px-4 py-2 rounded-full">Create Folder</button>
          <button className="bg-green-500 text-white px-4 py-2 rounded-full">Upload Document</button>
        </div>
      </div>

      <div className="space-y-4">
        {folders.map((folder) => (
          <div key={folder.id} className="border rounded-lg shadow-md bg-white p-4">
            <div className="flex justify-between items-center cursor-pointer" onClick={() => toggleFolder(folder.id)}>
              <span className="text-lg font-bold">{folder.name}</span>
              <span>{selectedFolder === folder.id ? '-' : '>'}</span>
            </div>
            {selectedFolder === folder.id && (
              <div className="mt-2">
                {folder.documents.map((document, index) => (
                  <p key={index} className="text-gray-600">{document}</p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default MyFolder;
